import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import { SignUpElement, SignUpType, usePopSignUp } from "@faire/retailer-visitor-shared/lib/popSignUp";
var LinkFormatting = function(chunks, handleSignUp) {
    return /*#__PURE__*/ _jsx(Button, {
        onClick: handleSignUp,
        variant: "tertiary",
        children: chunks
    });
};
export var UnlockBanner = function() {
    var isTabletAndAbove = useViewport().isTabletAndAbove;
    var popSignUp = usePopSignUp().popSignUp;
    var handleSignUp = function() {
        return popSignUp(SignUpType.GENERIC, function() {
            return null;
        }, {
            element: SignUpElement.TOP_BANNER,
            sourceId: "unlock_banner"
        });
    };
    if (isTabletAndAbove) {
        return /*#__PURE__*/ _jsx(Typography, {
            align: "center",
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "CGuPZF",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Unlock wholesale pricing on Faire. "
                    },
                    {
                        type: 8,
                        value: "LinkFormatting",
                        children: [
                            {
                                type: 0,
                                value: "Sign up today"
                            }
                        ]
                    }
                ],
                values: {
                    LinkFormatting: function(chunk) {
                        return LinkFormatting(chunk, handleSignUp);
                    }
                }
            })
        });
    }
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "/JTwWp",
            defaultMessage: [
                {
                    type: 0,
                    value: "Unlock wholesale pricing on Faire."
                }
            ]
        })
    });
};
export var LowMinimumsBanner = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "w7/1AI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Low minimums with thousands of brands"
                }
            ]
        })
    });
};
export var FreeReturnsBanner = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "izcYuF",
            defaultMessage: [
                {
                    type: 0,
                    value: "Free returns on all opening orders"
                }
            ]
        })
    });
};
export var BuyNowPay60DaysBanner = function() {
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "y69II2",
            defaultMessage: [
                {
                    type: 0,
                    value: "Buy now, pay 60 days later"
                }
            ]
        })
    });
};
